import { action, observable, reaction, makeObservable } from 'mobx';
import {VersionedContentLookup, X1Language} from '../../../domain';
import {arrayToMap, Disposers, PromiseState} from '../../../lib/helpers';
import {contentLookupService} from '../../../domain/services/ContentLookupService';

export class LanguageListLoader {
  @observable.ref
  state: PromiseState<VersionedContentLookup> | null;
  @observable.ref
  languages: readonly X1Language[];
  @observable.ref
  languageById: { [index: number]: X1Language };

  private readonly disposers = new Disposers();

  constructor() {
    makeObservable(this);
    this.state = null;
    this.languageById = {};
    this.languages = [];
    this.setup();
  }

  private setup() {
    this.disposers.add(
      reaction(() => this.state?.value,
        this.onStateChange));
  }

  load = () => {
    if (this.state?.isPending === true)
      return;
    this.state = contentLookupService.load();
  };

  refresh = () => {
    if (this.state?.isPending === true)
      return;
    this.state = contentLookupService.refresh();
  };

  @action
  onStateChange = () => {
    this.languages = [];
    this.languageById = {};

    if (this.state?.isResolved !== true)
      return;

    this.languages = this.state.value.lookup.Languages;
    this.languageById = arrayToMap(this.languages, x => x.Id);
  };

  dispose = () => {
    this.disposers.dispose();
  };
}
